import { AutomationTriggerEvent } from '@/gql/graphql';
import { AutomationTriggerEvents } from '@payaca/types/automationTypes';

/**
 * this is repeated from `apps/server-backend/src/provider/graphql/queries/automation/helpers.ts`
 * but we don't yet have a package for shared graphql types
 */
export const triggerEventToGqlEnum: Record<
  AutomationTriggerEvents,
  AutomationTriggerEvent
> = {
  Created: 'CREATED',
  'Signature added': 'SIGNATURE_ADDED',
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
  Cancelled: 'CANCELLED',
  Sent: 'SENT',
  Expired: 'EXPIRED',
  'Payment Received': 'PAYMENT_RECEIVED',
  'Fully Paid': 'FULLY_PAID',
  Assigned: 'ASSIGNED',
  Tagged: 'TAGGED',
  'Added to pipeline': 'ADDED_TO_PIPELINE',
  'Pipeline stage changed': 'PIPELINE_STAGE_CHANGED',
  'Task status changed': 'TASK_STATUS_CHANGED',
  'Pipeline stage changed yesterday': 'PIPELINE_STAGE_CHANGED_YESTERDAY',
  'Pipeline stage changed 2 days ago': 'PIPELINE_STAGE_CHANGED_2_DAYS_AGO',
  'Pipeline stage changed 3 days ago': 'PIPELINE_STAGE_CHANGED_3_DAYS_AGO',
  'Pipeline stage changed 4 days ago': 'PIPELINE_STAGE_CHANGED_4_DAYS_AGO',
  'Pipeline stage changed 5 days ago': 'PIPELINE_STAGE_CHANGED_5_DAYS_AGO',
  'Pipeline stage changed 6 days ago': 'PIPELINE_STAGE_CHANGED_6_DAYS_AGO',
  'Pipeline stage changed 7 days ago': 'PIPELINE_STAGE_CHANGED_7_DAYS_AGO',
  'Scheduled Daily Run': 'SCHEDULED_DAILY_RUN',
  'Realtime Run': 'REALTIME_RUN',
  'Due in 7 days': 'DUE_IN_7_DAYS',
  'Due in 3 days': 'DUE_IN_3_DAYS',
  'Due in 1 day': 'DUE_IN_1_DAY',
  'Due today': 'DUE_TODAY',
  'Due yesterday': 'DUE_YESTERDAY',
  'Due 3 days ago': 'DUE_3_DAYS_AGO',
  'Due 7 days ago': 'DUE_7_DAYS_AGO',
  'Expires in 28 days': 'EXPIRES_IN_28_DAYS',
  'Expires in 21 days': 'EXPIRES_IN_21_DAYS',
  'Expires in 14 days': 'EXPIRES_IN_14_DAYS',
  'Expires in 7 days': 'EXPIRES_IN_7_DAYS',
  'Expires in 3 days': 'EXPIRES_IN_3_DAYS',
  'Expires in 1 day': 'EXPIRES_IN_1_DAY',
  'Expires today': 'EXPIRES_TODAY',
  'Expired yesterday': 'EXPIRED_YESTERDAY',
  'Expired 3 days ago': 'EXPIRED_3_DAYS_AGO',
  'Expired 7 days ago': 'EXPIRED_7_DAYS_AGO',
  'Starts in 3 months': 'STARTS_IN_3_MONTHS',
  'Starts in 1 month': 'STARTS_IN_1_MONTH',
  'Starts in 21 days': 'STARTS_IN_21_DAYS',
  'Starts in 14 days': 'STARTS_IN_14_DAYS',
  'Starts in 7 days': 'STARTS_IN_7_DAYS',
  'Starts in 3 days': 'STARTS_IN_3_DAYS',
  'Starts in 1 day': 'STARTS_IN_1_DAY',
  'Starts in 1 hour': 'STARTS_IN_1_HOUR',
  'Starts now': 'STARTS_NOW',
  'Starts today': 'STARTS_TODAY',
  'Finishes now': 'FINISHES_NOW',
  'Finishes today': 'FINISHES_TODAY',
  'Finished yesterday': 'FINISHED_YESTERDAY',
  'Finished 3 days ago': 'FINISHED_3_DAYS_AGO',
  'Finished 7 days ago': 'FINISHED_7_DAYS_AGO',
  'Finished 1 month ago': 'FINISHED_1_MONTH_AGO',
  'Finished 11 months ago': 'FINISHED_11_MONTHS_AGO',
  'Finished 1 year ago': 'FINISHED_1_YEAR_AGO',
  'Event task status changed': 'EVENT_TASK_STATUS_CHANGED',
  'Connection application status changed':
    'CONNECTION_APPLICATION_STATUS_CHANGED',
  'Acceptance removed': 'ACCEPTANCE_REMOVED',
  Voided: 'VOIDED',
};
